import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aif_identifier_lei: {
    name: 'AIF LEI Code',
    order: 24
  },
  aif_identifier_isin: {
    name: 'AIF ISIN Code',
    order: 25
  },
  aif_identifier_cusip: {
    name: 'AIF CUSIP Code',
    order: 26
  },
  aif_identifier_sedol: {
    name: 'AIF SEDOL Code',
    order: 27
  },
  aif_identifier_ticker: {
    name: 'AIF Bloomberg Code',
    order: 28
  },
  aif_identifier_ric: {
    name: 'AIF Reuters Code',
    order: 29
  },
  aif_identifier_ecb: {
    name: 'AIF ECB Code',
    order: 30
  },
  old_reporting_member_state: {
    name: 'Old AIF national identifier - Reporting Member State',
    order: 31
  },
  old_aif_national_code: {
    name: 'Old AIF national identifier - National Code',
    order: 32
  }
};

export const FundIdentificationCodes3 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FUND_ID_CODES,
    onChangeFund,
    schema: schema.FUND_ID_CODES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FUND_ID_CODES?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'FUND_ID_CODES'
  });

  return (
    <Table
      id="reporttables-fund-identification-codes-3-table"
      handleChanges={onChange}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      columns={columns}
      rows={rows}
    />
  );
};
